import React from "react";

const Question = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-question"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-question"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,20a1,1,0,1,1,1-1A1,1,0,0,1,12,20Zm1.93-7.494A1.982,1.982,0,0,0,13,14.257V15a1,1,0,0,1-2,0v-.743a3.954,3.954,0,0,1,1.964-3.5,2,2,0,0,0,1-2.125,2.024,2.024,0,0,0-1.6-1.595A2,2,0,0,0,10,9,1,1,0,0,1,8,9a4,4,0,1,1,5.93,3.505Z" />
    </svg>
  );
};

export default Question;
